import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { selectModalVisibleByKey } from '_store/modals/selector';
import { hideModal } from '_store/modals/slice';
import { selectLoading } from '_store/oauth/selector';
import { getOAuthUrl } from '_store/oauth/slice';
import { selectActiveMainProductId } from '_store/order/selector';
import { selectCustomerId } from '_store/user/selector';

import Button from 'components/atomic/Button';
import Icon from 'components/atomic/Icon';
import Spinner from 'components/atomic/Spinner';
import Text from 'components/atomic/layouts/Text';

const StyledModalBody = styled(Modal.Body)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spaces.large4X}px;
`;

const StyledCloseActionContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: ${-theme.spaces.large3X}px;
  right: 0;
  font-family: 'Inter';
  font-style: normal;
  font-size: ${theme.fontSizes.regular}px;
  font-weight: 400;
  color: ${theme.colors.white};
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  margin-right: ${theme.spaces.small2X}px;
`;

const StyledConfirmActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
  margin-top: ${theme.spaces.small - 2}px;
`;

const StyledSpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const XeroAuthConfirmationModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(selectModalVisibleByKey(MODAL_KEYS.xeroAuthConfirm));
  const loading = useSelector(selectLoading);
  const customerId = useSelector(selectCustomerId);
  const productId = useSelector(selectActiveMainProductId);

  const handleClose = () => {
    dispatch(hideModal({ key: MODAL_KEYS.xeroAuthConfirm }));
  };

  const handleConfirm = () => {
    dispatch(getOAuthUrl({ customerId, productId }));
  };

  return (
    <Modal
      dialogClassName="xero-auth-confirmation-modal"
      show={visible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <StyledModalBody>
        <StyledCloseActionContainer onClick={handleClose}>
          <StyledIconContainer>
            <Icon alias={ICON_ALIASES.close} color={theme.colors.white} />
          </StyledIconContainer>
          Close
        </StyledCloseActionContainer>
        <Text
          size={theme.fontSizes.largeX}
          weight={700}
          color={theme.colors.gray.primary}
          bottomSpace={theme.spaces.medium}
        >
          Authentication required
        </Text>
        <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary} bottomSpace={theme.spaces.medium}>
          In order to receive data related to this order You must connect to the Xero account
        </Text>
        <StyledConfirmActionContainer>
          <Button color={theme.colors.indigo.primary} disabled={loading} onClick={handleConfirm}>
            Authenticate
          </Button>
          {loading && (
            <StyledSpinnerContainer>
              <Spinner color={theme.colors.indigo.superLight} />
            </StyledSpinnerContainer>
          )}
        </StyledConfirmActionContainer>
      </StyledModalBody>
    </Modal>
  );
};

export default XeroAuthConfirmationModal;
